import React from 'react';

const UserCashPlanFormModal = React.lazy(() => import('../components/FormModal'));
const userCashPlanModalRegistry = {
    core_userCashPlanId: UserCashPlanFormModal
};
export default userCashPlanModalRegistry;
